<template>
	<router-link
		:to="{ name: alertRouteName, params: { user_uid: user_uid, watch_id: watch_id, type_id: type_id, alert_id: value.id, data: value } }"
		class="idi-row"
		:class="cssClass(value.urgency_type)">
		<div class="idi-cell"><div class="bullet"></div></div>
		<div class="name">{{ $t('labels.general.'+value.name.replace(/ /g, '_').replace(/'/g, '´').toLowerCase()) }}</div>
		<div class="idi-cell events">{{ value.events }}</div>
		<div class="idi-cell first" :title="first">{{ first }} <span v-html="units"></span></div>
		<div class="idi-cell last" :title="last">{{ last }} <span v-html="units"></span></div>
		<div class="idi-cell date" :title="value.date">{{ value.date | timeAgo(vue) }}</div>
		<div class="idi-cell state" :title="stateText(value.status)">{{ stateText(value.status) }}</div>
	</router-link>
</template>

<script>
import Readings from '@/utils/readings'
export default {
	props: [
		'user_uid',
		'watch_id',
		'type_id',
		'value',
		'units'
	],
	data () {
		return {
			vue: this,
			states: new Map([
				[ 0, this.$t('labels.general.unresponded') ],
				[ 1, this.$t('labels.general.in_progress') ],
				[ 2, this.$t('labels.general.done') ],
				[ 4, this.$t('labels.general.canceled') ]
			])
		}
	},
	computed: {
		first () {
			switch (parseInt(this.value.type_reading_id)) {
				case Readings.TYPE_BLOOD_PRESSURE:
					return `${this.value.values.first.systolic} ${this.value.values.first.diastolic}`
				case Readings.TYPE_GEOFENCING:
					return `${Number(this.value.values.first.latitude).toFixed(2)} ${Number(this.value.values.first.longitude).toFixed(2)}`
				default:
					return this.value.values.first.value
			}
		},
		last () {
			switch (parseInt(this.value.type_reading_id)) {
				case Readings.TYPE_BLOOD_PRESSURE:
					return `${this.value.values.last.systolic} ${this.value.values.last.diastolic}`
				case Readings.TYPE_GEOFENCING:
					return `${Number(this.value.values.last.latitude).toFixed(2)} ${Number(this.value.values.last.longitude).toFixed(2)}`
				default:
					return this.value.values.last.value
			}
		},
		isGeofencing () {
			return parseInt(this.type_id) === Readings.TYPE_GEOFENCING
		},
		alertRouteName () {
			return this.isGeofencing ? 'WatchGeofencingAlertViewResumeV2' : 'WatchBiometricAlertViewResumeV2'
		}
	},
	methods: {
		cssClass (urgency) {
			switch (parseInt(urgency)) {
				case 1:
					return 'urgency-min'
				case 2:
					return 'urgency-med'
				case 3:
					return 'urgency-max'
				default:
					return ''
			}
		},
		stateText (state) {
			const key = parseInt(state)
			return this.states.has(key) ? this.states.get(key) : ''
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/alertsV2/ReadingsAlertHistoryRow.vue